import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface Props {
    className?: string;
}

export const HotlineInfoPoints = (props: Props) => {
    return (
        <div className={cx(listStyle, props.className)}>
            {LIST_ITEMS.map((item, index) => (
                <div key={index} className={listItemStyle}>
                    <CheckIcon size="1.6" wrapperSize="1.6" wrapperColor="var(--colors-success)" />
                    <Text variant="body_copy_2" as="p">
                        {item}
                    </Text>
                </div>
            ))}
        </div>
    );
};

const LIST_ITEMS: ReactNode[] = [
    <>
        <strong>Bezpłatnie</strong> wyselekcjonujemy mieszkania idealnie dopasowane do Twoich potrzeb.
    </>,
    <>
        <strong>Oszczędzimy Twój czas,</strong> odrzucając nietrafione ogłoszenia.
    </>,
    <>
        <strong>Zapewnimy Ci wsparcie</strong> doradcy mieszkaniowego na każdym etapie.
    </>
];

const listStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mb: 3
});

const listItemStyle = css({
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
    "& > *:first-child": {
        mt: "3px"
    }
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface Props {
    className?: string;
}

export const HotlineInfoPoints = (props: Props) => {
    return (
        <div className={cx(listStyle, props.className)}>
            {LIST_ITEMS.map((item, index) => (
                <div key={index} className={listItemStyle}>
                    <CheckIcon size="1.6" wrapperSize="1.6" wrapperColor="var(--colors-success)" />
                    <Text variant="body_copy_2" as="p">
                        {item}
                    </Text>
                </div>
            ))}
        </div>
    );
};

const LIST_ITEMS: ReactNode[] = [
    <>
        <strong>Bezpłatnie</strong> wyselekcjonujemy mieszkania idealnie dopasowane do Twoich potrzeb.
    </>,
    <>
        <strong>Oszczędzimy Twój czas,</strong> odrzucając nietrafione ogłoszenia.
    </>,
    <>
        <strong>Zapewnimy Ci wsparcie</strong> doradcy mieszkaniowego na każdym etapie.
    </>
];

const listStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mb: 3
});

const listItemStyle = css({
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
    "& > *:first-child": {
        mt: "3px"
    }
});
